import { Box, BoxProps } from "@chakra-ui/react";
import { FiBookmark } from "react-icons/fi";

export const BookmarkIcon = (props: BoxProps) => {
  return <Box as={FiBookmark} height="20px" width="20px" {...props} />;
};
